import React from "react"
import PropTypes from "prop-types"
import { className } from "@/helpers/className"

export const FormActionButtons = ({ onCancel, isSubmitDisabled, isMobile, loading }) => {
  return (
    <div className="d-flex gap-1 align-items-center justify-content-end flex-grow-1">
      {loading && <div className="spinner-border text-primary" />}
      {onCancel && (
        <button
          className={className("btn btn-link text-black text-no-wrap", isMobile && "w-100")}
          type="button"
          onClick={onCancel}
        >
          Cancel
        </button>
      )}
      <button
        className={className("btn btn-primary text-no-wrap", isMobile && "w-100")}
        type="submit"
        disabled={isSubmitDisabled}
      >
        Save
      </button>
    </div>
  )
}

FormActionButtons.propTypes = {
  onCancel: PropTypes.func,
  isSubmitDisabled: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
}
